<nb-card size="large">
  <nb-card-header>
    {{'MAIN.MESSAGE_MODAL.TITLE' | translate}}
  </nb-card-header>
  <nb-card-body>
    <div *ngFor="let message of messageList; let id = index">
      <nb-alert
        status="{{message.title == 'OK' && 'success' || message.title == 'ERROR' && 'danger' || message.title == 'ALERTA' && 'warning' || message.title == 'INFO' && 'info'}}">
        <i
          class="{{message.title == 'OK' && 'fa fa-check-double' || message.title == 'ERROR' && 'fa fa-times' || message.title == 'ALERTA' && 'fa fa-exclamation-triangle'|| message.title == 'INFO' && 'fa fa-info'}}"></i>
        <strong>{{message.title}}</strong>{{message.message}}
        <p style="text-align: right">{{message.date | date:'medium'}}</p>
        <button nbButton *ngIf="message.messages !== null && message.messages !== undefined && message.messages.length > 0" status="success" style="width: 50px; margin-left: auto;"
          (click)="showList(id)"><i class="fas fa-list-ul"></i></button>
        <div *ngIf="(id == showMessageList) && isVisible">
          <div *ngFor="let detail of message.messages">
            <span>- </span>
            <span>{{detail}}</span>
          </div>
        </div>
      </nb-alert>
    </div>
    <button nbButton status="info" (click)=clear() outline><i class="fas fa-eraser"></i> {{
      "GENERAL_FORM.BTN_CLEAN" | translate }}</button>
  </nb-card-body>
</nb-card>
